export abstract class RegularExpressions {
    // Letters, hyphens, apostrophes, spaces only — no numbers or special characters
    public static readonly FirstName = /^[A-Za-z'\s\-]*$/;
    public static readonly LastName = /^[A-Za-z'\s\-]*$/;
    // Single letter A-Z only (maxLength(1) enforces single-char limit)
    public static readonly MiddleInitial = /^[A-Za-z]*$/;
    public static readonly EmployeeCode = /^[A-Za-z0-9'\s\-]*$/;
    // US 5 digit, US 5+4, or Canadian A1A 1A1 / A1A-1A1
    public static readonly ZipCode = /^((\d{5}-\d{4})|(\d{5})|([A-Za-z]\d[A-Za-z][\s\-]\d[A-Za-z]\d))$/;
    public static readonly SocialSecurityNumber = /^\d{3}-\d{2}-\d{4}$|\d{3}-\d{3}-\d{3}$/;
    public static readonly Currency = /^\d+(\.\d{1,2})?/;
    public static readonly Text = /[a-zA-Z][a-zA-Z0-9-_. ]/;
    public static readonly Pin = /^\d{6}$/;
    // US phone: (###) ###-#### or ###-###-#### where area code cannot start with 0 or 1
    public static readonly Phone = /^(\([2-9]\d{2}\) \d{3}-\d{4}|[2-9]\d{2}-\d{3}-\d{4})$/;
    // Street address: letters, digits, spaces, periods, commas, hyphens, forward slashes, #
    public static readonly StreetAddress = /^[A-Za-z0-9\s.,\-/#]*$/;
    // City: letters (including accented), spaces, hyphens, apostrophes
    public static readonly City = /^[A-Za-zÀ-ÿ\s\-']*$/;
}
